/*
 * reconSort — display-only comparators for Part Number and Asset Tag lists.
 * ---------------------------------------------------------------------------
 * Pure functions. These NEVER mutate their arguments and the module itself
 * holds no state — callers sort a COPY ([...arr].sort(...)) so stored order is
 * never affected. Used by the recon detail panels + Asset Registry detail to
 * give a stable, type-prioritized render order without touching persistence.
 */

export const PN_TYPE_ORDER = [
  'INVENTORY', 'INV_OEM_PN', 'SUPPLIER', 'TIER_1', 'COMPONENT',
  'COMPONENT_PN', 'FG', 'PLM', 'BASE', 'PRODUCTION', 'SERVICE',
]; // TBD pinned last; unknown types rank just above TBD, alpha among peers

function pnRank(type) {
  const t = (type || 'TBD').toUpperCase();
  if (t === 'TBD') return 9999;
  const i = PN_TYPE_ORDER.indexOf(t);
  return i >= 0 ? i : 9000;
}

const collate = (a, b) =>
  String(a || '').localeCompare(String(b || ''), undefined,
    { numeric: true, sensitivity: 'base' });

export function comparePartNumbers(a, b) {
  const ra = pnRank(a.part_number_type), rb = pnRank(b.part_number_type);
  if (ra !== rb) return ra - rb;
  if (ra === 9000) {                       // unknown band: alpha by type first
    const c = collate(a.part_number_type, b.part_number_type);
    if (c !== 0) return c;
  }
  return collate(a.part_number, b.part_number);
}

export function compareAssetTags(a, b) {
  return collate(a.tag_value || a.asset_tag_value, b.tag_value || b.asset_tag_value);
}
